import React from "react";
import HeaderCardEventSlider from "./headerCardEventSlider/headerCardEventSlider";
import BodyCardEventSlider from "./bodyCardEventSlider/bodyCardEventSlider";
import FooterCardEventSlider from "./footerCardEventSlider/footerCardEventSlider";
import "./cardEventSlider.sass";

export default function CardEventSlider({ item, flagMomios, indice, longitud, patrocinador }) {

    const patrocinadorMetadata = item[`${patrocinador.toLowerCase()}_metadata`] || {};

    return (
        <div className={indice + 1 < longitud ? "container-card-evento-slider card-middle-slider pr1" : "container-card-evento-slider pr1"} key={item.id_juego}>
            
            <HeaderCardEventSlider nameEvent={item.liga} classEvent={item.class} urlEvent={item.opta_event_url} game_name={item.game_name} sport={item.sport}
            venue_name={item.venue_name} venue_state={item.venue_state} venue_country={item.venue_country} podium={item.race_results.podium}
            />
    
            <BodyCardEventSlider
                imgL={item.left_image} 
                momioL={patrocinadorMetadata?.left_mm} 
                nameL={item.left_name} scoreL={item.left_score} claseL={item.left_class} 
                urlMomioL={patrocinadorMetadata?.left_url_mm}
                imgR={item.right_image} 
                momioR={patrocinadorMetadata?.right_mm} 
                nameR={item.right_name} scoreR={item.right_score} claseR={item.right_class} 
                urlMomioR={patrocinadorMetadata?.right_url_mm}
                urlMomioM={patrocinadorMetadata?.middle_url_mm} 
                momioM={patrocinadorMetadata?.middle_mm}
                classTeamL={item.left_class}
                classTeamR={item.right_class}
                urlEvento={item.opta_event_url}
                flagMomios={flagMomios}
                classGame={item.class}
                sport={item.sport}
                podium={item.race_results.podium}
                venue_name={item.venue_name}
                venue_state={item.venue_state} 
                venue_country={item.venue_country}
                circuit_image={item.race_results.circuit_image}
                opta_event_url={item.opta_event_url}
            />

            <FooterCardEventSlider
                urlmomioEvento={patrocinador === 'codere' ? "https://a2.adform.net/C/?bn=78310502" : patrocinadorMetadata?.url_mm_evento}
                statusEvent={item.period_title}
                classEvent={item.class} 
                dateUTC={item.utc_date}
                flagMomios={flagMomios}
                urlEvento={item.opta_event_url}
                vueltas={item.race_results.laps}
                sport={item.sport}
                classPatrocinador={`buttonJuegaAqui-${patrocinador.toLowerCase()}`}
            />
        </div>
    );
}
